<template>
<section class="mx-auto w-1/1 lg:w-8/12 px-4 py-24">
  <slot/>
</section>
</template>
